
const steps = {
	0 : {
		'MIN' : 0.073,
		'TYP' : 0.073,
		'MAX' : 0.073,
	},
	15 : {
		'MIN' : 0.0679,
		'TYP' : 0.073,
		'MAX' : 0.0781,
	},
	30 : {
		'MIN' : 0.0694,
		'TYP' : 0.073,
		'MAX' : 0.0767,
	}
}

const getStep = (value, acc) => {
	if (value > 30) return steps[30][acc]
	if (value > 15) return steps[15][acc]
	return steps[0][acc.value]
}

const ValueTransform = (value, acc) => {
	const v = parseInt(value) + 1
	return v * getStep(v, acc)
}

export default ValueTransform
